











import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class TaskTypeNameInput extends Vue {
  @Prop({ default: "" }) value!: string;
  @Prop({ type: Boolean }) autofocus!: boolean;

  get name() {
    return this.value;
  }

  set name(value: string) {
    this.$emit("input", value);
  }
}
